import React, {useState} from 'react'
import styled from 'styled-components'
import Header from '../../components/Header/Header'
import HeaderButton from '../../components/Header/HeaderButton'
import HeaderTitle from '../../components/Header/HeaderTitle'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {useUIDispatch, useUIState} from '../../context/UIContext'
import ServiceCatalogItems from '../../containers/ServiceCatalog/ServiceCatalogItems'
import Icons from '../../components/Icons'
import ArchibusLogo from '../../assets/img/archibus-icon-essential.png'
import BurgerMenu from '../../components/BurgerMenu/BurgerMenu'
import {useUserState} from '../../context/UserContext'
import {LOGON_CONTAINER, REGISTER_KIOSK} from '../../constants/const'
import {getAvailableActions, useConfigState} from '../../context/ConfigContext'
import {isServiceCatalog} from '../../utils/routing'
import MediaQuery from 'react-responsive'

import {
  MenuButtonContainer,
  MenuItem,
  MenuItemText,
  MenuLogo
} from '../../components/BurgerMenu/MenuStyles'
import * as Security from '../../api/archibus/SecurityApi'

const ServiceCatalog = ({parentPage = null, onClose, isQrView}) => {
  const [headerTitle, setHeaderTitle] = useState('')
  const localeState = useLocaleState()
  const uiDispatch = useUIDispatch()
  const {isKiosk} = useUIState()
  const {user} = useUserState()

  const configState = useConfigState()
  const {OrganizationName} = configState.params
  const availableActions = getAvailableActions(configState)

  const {workingspace, meetingspace, createrequest} = availableActions

  // isCatalogView is true when the Service Catalog is the primary app view.

  const isCatalogView = isServiceCatalog()

  const onCancel = () => {
    if (isKiosk) {
      uiDispatch({
        type: 'showSearch',
        payload: {show: false, type: null, options: {}}
      })
    }

    if (isQrView) {
      onClose()
    } else {
      uiDispatch({
        type: 'setContent',
        payload: {content: parentPage || 'DASHBOARD'}
      })
    }
  }
  
  const onRegisterKiosk = () =>
  	uiDispatch({type: 'setContent', payload: {content: REGISTER_KIOSK}})
  
  const onSignOnButtonClick = async () => {
    await Security.logout()
    uiDispatch({type: 'setContent', payload: {content: LOGON_CONTAINER}})
  }

  const onServiceRequestsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'SERVICE_MORE_LIST'}
    })

  const onMeetingReservationsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'MEETINGS_MORE_LIST'}
    })

  const onWorkspaceReservationsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'WORKSPACE_MORE_LIST'}
    })

  const onCatalogItemChange = ({title}) => setHeaderTitle(title)
  
  const showRegisterKiosk =
	user.role === '4 - CLIENT ADMINISTRATOR (ACP)' ||
	user.role === '4 - PARTNER ADMINISTRATOR (ACP)' ||
	user.role === 'ACTIVITY LICENSEE' ||
	user.role === 'SYSTEM ADMINISTRATOR (ACP)' ||
	user.role === 'SYSTEM ADMINISTRATOR' ||
	user.role === 'ARCHIBUS ADMINISTRATOR' ||
	user.role === '4 - PROCESS OWNER' ||
	user.role === '4 - PROCESS OWNER - ESSENTIAL (ACP)' ||
    user.role === '4 - PROCESS OWNER - MODULES (ACP)' ||
    user.role === '4 - PROCESS OWNER - FOUNDATIONS (ACP)' ||
    user.role === '4 - PROCESS OWNER - PROFESSIONAL (ACP)'
    	
  const isGuestUser =
    user.name === 'GUEST'

  return (
    <MediaQuery maxWidth={420}>
      {matches => (
        <Container>
          <Header
            rightContent={
              <>
                {isCatalogView && !isKiosk ? (
                  <BurgerMenu user={user}>
                    {showRegisterKiosk && (
                      <MenuButtonContainer onClick={onRegisterKiosk} show>
                        <MenuItem>
                          <Icons icon="SETTINGS" />
                          <MenuItemText>
                            {_L({key: 'Register Kiosk', localeState})}
                          </MenuItemText>
                        </MenuItem>
                      </MenuButtonContainer>
                    )}  
                    {!isGuestUser && (
                      <div>
                      <MenuButtonContainer
                        onClick={onServiceRequestsClick}
                        show={createrequest}
                      >
                        <MenuItem>
                          <Icons icon="SERVICE_REQUESTS" />
                          <MenuItemText>
                            {_L({key: 'Service Requests', localeState})}
                          </MenuItemText>
                        </MenuItem>
                      </MenuButtonContainer>

                      <MenuButtonContainer
                        onClick={onMeetingReservationsClick}
                        show={meetingspace}
                      >
                        <MenuItem>
                          <Icons icon="MEETING_RESERVATION" />
                          <MenuItemText>
                            {_L({key: 'Meeting Reservations', localeState})}
                          </MenuItemText>
                        </MenuItem>
                      </MenuButtonContainer>

                      <MenuButtonContainer
                        onClick={onWorkspaceReservationsClick}
                        show={workingspace}
                      >
                        <MenuItem>
                          <Icons icon="WORKSPACE_RESERVATION" />
                          <MenuItemText>
                            {_L({key: 'Workspace Reservations', localeState})}
                          </MenuItemText>
                        </MenuItem>
                      </MenuButtonContainer>
                      </div>
                    )}
                    <MenuButtonContainer onClick={onSignOnButtonClick} show>
                      <MenuItem>
                        <Icons icon="LOG_OUT" />
                        <MenuItemText>
                          {_L({key: 'Log Out', localeState})}
                        </MenuItemText>
                      </MenuItem>
                    </MenuButtonContainer>
                    <MenuButtonContainer show>
                      <MenuLogo>
                        <div>
                          <img src={ArchibusLogo} alt="logo" />
                        </div>
                        <div>{_L({key: 'Powered by', localeState})}</div>
                        <div>{_L({key: 'Archibus', localeState})}</div>
                      </MenuLogo>
                    </MenuButtonContainer>
                  </BurgerMenu>
                ) : (
                  <HeaderButton
                    label={_L({key: 'Home', localeState})}
                    onClick={onCancel}
                  />
                )}
              </>
            }
            centerContent={<HeaderTitle title={matches ? '' : headerTitle} />}
            leftContent={
              <OrganizationContainer>
                <OrganizationText>{OrganizationName}</OrganizationText>
              </OrganizationContainer>
            }
          />
          <ServiceCatalogItems
            parentPage={parentPage}
            onCatalogItemChange={onCatalogItemChange}
          />
        </Container>
      )}
    </MediaQuery>
  )
}
export default ServiceCatalog

ServiceCatalog.defaultProps = {
  parentPage: 'SERVICE_CATALOG',
  onClose: () => {},
  isQrView: false
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: #eff0f4;
`

const OrganizationContainer = styled.div`
  padding: 8px 8px 8px 0;

  @media (max-width: 420px) {
    padding: 0 8px 0 0;
  }
`

const OrganizationText = styled.div`
  font-weight: 700;
  color: #ffffff;
  font-size: 28px;
  letter-spacing: -0.65px;

  @media (max-width: 1024px) {
    font-size: 20px;
  }
`
